import { makeVar } from '@apollo/client';

export const loginStepVar = makeVar<'login' | 'mfa' | 'newPassword'>('login');
